import { useEffect, useState } from "react";
import { FilterIcon, StyledMenuTitle, StyledSidebar } from "./index.styled";
import { StyledFilterMenu } from "./index.styled";
import { useIntl } from "react-intl";
import { FiFilter } from "react-icons/fi";
import { NoteTagType } from "@lib/types/Note";
import { MenuProps } from "antd";

type FilterType = {
  type: NoteTagType | "all";
  key?: string;
  active: boolean;
};

type MenuItem = Required<MenuProps>["items"][number];

type Props = {
  setActiveKey: (key: string) => void;
};

export default function Filters({ setActiveKey }: Props) {
  const { messages } = useIntl();
  const [activeFilters, setActiveFilters] = useState<FilterType[]>([
    { type: "all", active: true },
    { type: NoteTagType.CUSTOMER, key: "customerId", active: false },
    { type: NoteTagType.PRODUCT, key: "productId", active: false },
    { type: NoteTagType.INVOICE, key: "invoiceId", active: false },
  ]);

  const handleFilterChange = ({ key }) => {
    setActiveFilters((prev) =>
      prev.map((filter) => ({
        ...filter,
        active: filter.type === key,
      })),
    );
  };

  useEffect(() => {
    setActiveKey(activeFilters.find((f) => f.active)?.key);
  }, [activeFilters]);

  const getFilterMenuItems = (): MenuItem[] => {
    return [
      {
        key: "all",
        icon: <FilterIcon />,
        label: (messages["common.all"] as string) || "All Notes",
      },
      {
        key: NoteTagType.CUSTOMER,
        icon: <FilterIcon type={NoteTagType.CUSTOMER} />,
        label: (messages["common.customer"] as string) || "Customer Notes",
      },
      {
        key: NoteTagType.PRODUCT,
        icon: <FilterIcon type={NoteTagType.PRODUCT} />,
        label: (messages["common.product"] as string) || "Product Notes",
      },
      {
        key: NoteTagType.INVOICE,
        icon: <FilterIcon type={NoteTagType.INVOICE} />,
        label: (messages["common.invoice"] as string) || "Invoice Notes",
      },
    ];
  };

  return (
    <StyledSidebar>
      <StyledMenuTitle>
        <FiFilter style={{ marginRight: "8px" }} />
        {(messages["common.filter"] as string) || "Filter"}
      </StyledMenuTitle>
      <StyledFilterMenu
        mode="inline"
        selectedKeys={[activeFilters.find((f) => f.active)?.type || "all"]}
        items={getFilterMenuItems()}
        onClick={handleFilterChange}
      />
    </StyledSidebar>
  );
}
